import React, { useEffect, useState } from 'react';
// import { Divider, NotListing } from '../svg'
import { useSelector } from 'react-redux';
import { Divider, NotListing } from '../../../svg';
import BiCheckCircle from '@meronex/icons/bi/BiCheckCircle';
import { winnreAuth } from '../../../../../utils/axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { getConfig } from '../../../../../utils/config';

const PropertyList = ({
    setStep,
    propertyData,
    selectedProject,
    setSelectedProject,
    setListOtherProperty,
    setFurnishType,
    setRentOutTime,
    setExpectedRent,
    setSecurityDeposit,
    setCity,
    setAddress,
    setState,
    resetPin,
    setShowUnregisteredModal
}) => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const userName = useSelector((state) => state.auth.userName);
    const [projectChanged, setProjectChanged] = useState(false);
    const userStatus = useSelector((state) => state.auth.userDetails?.status);
    const config = getConfig();
    useEffect(() => {
        if (propertyData?.length === 1) {
            const [singleProperty] = propertyData;
            setSelectedProject({
                propertyId: singleProperty?.id,
                projectId: singleProperty?.projectId,
                projectName: singleProperty?.projectName,
                image: singleProperty?.projectBgImage,
                unitArea: singleProperty?.unitArea || '',
                configuration: singleProperty?.configuration || ''
            });
            setProjectChanged(true);
        }
    }, [propertyData, setSelectedProject]);

    const handleProject = (project) => {
        if (
            propertyData?.length === 1 ||
            selectedProject?.projectId !== project?.projectId
        ) {
            setProjectChanged(true);
        }
        setSelectedProject({
            propertyId: project?.id,
            projectId: project?.projectId,
            projectName: project?.projectName,
            image: project?.projectBgImage,
            unitArea: project?.unitArea || '',
            configuration: project?.configuration || ''
        });
    };

    const listPropertyHandler = () => {
        if (userStatus !== 'REGISTERED') {
            setShowUnregisteredModal(true);
            return;
        } else {
            setStep((prev) => prev + 1);
            setSelectedProject(null);
            setListOtherProperty(true);
            setAddress('');
            setCity('');
            setState('');
            resetPin();
            setFurnishType(null);
            setExpectedRent(null);
            setRentOutTime(null);
            setSecurityDeposit(null);
        }
    };

    console.log('Selected Project', selectedProject);

    return (
        <>
            {(isAuthenticated || false) && (
                <div className="bg-white text-black rounded-2xl p-3 lg:p-6 space-y-3 shadow-xl">
                    <div className="text-center pt-2 flex flex-col justify-center">
                        <h2 className="text-[18px] font-bold">
                            Start your earnings
                        </h2>
                        <p className="text-[16px] pb-6">
                            Enter the details and list your property
                        </p>
                        {Divider}
                    </div>

                    <div className="flex items-center space-x-3 text-[17px]">
                        <div className="bg-primary rounded-full w-[50px] h-[50px] flex justify-center items-center text-white">
                            <h2 className="text-[20px] font-semibold">
                                {typeof userName === 'string' &&
                                userName.length > 0
                                    ? userName.charAt(0).toUpperCase()
                                    : ''}
                            </h2>
                        </div>
                        <div>
                            <h3>Hello {userName},</h3>
                            <p className="text-[15px] font-bold">
                                Select Project you want to rentout
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        {propertyData?.map((project) => (
                            <div
                                className={`p-2 border border-gray-300 rounded-xl cursor-pointer ${
                                    selectedProject?.projectId ===
                                    project?.projectId
                                        ? 'bg-gray-50'
                                        : ''
                                }`}
                                onClick={() => handleProject(project)}
                            >
                                <div className="flex space-x-3 items-center">
                                    <label
                                        key={project?.projectId}
                                        className="relative inline-block cursor-pointer"
                                    >
                                        <input
                                            type="radio"
                                            name="project"
                                            value={project?.projectId}
                                            checked={
                                                selectedProject &&
                                                selectedProject?.projectId ===
                                                    project?.projectId
                                            }
                                            className="absolute inset-0 opacity-0 cursor-pointer"
                                        />
                                        <div className="relative ">
                                            <img
                                                src={project?.projectBgImage}
                                                alt={project?.projectName}
                                                className="rounded-lg w-[100px] h-[70px] object-cover object-center"
                                            />
                                            {selectedProject &&
                                                selectedProject?.projectId ===
                                                    project?.projectId && (
                                                    <>
                                                        <div className="absolute top-0 left-0 w-full h-full bg-primary opacity-70 rounded-xl"></div>
                                                        <BiCheckCircle className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  text-lg text-white" />
                                                    </>
                                                )}
                                        </div>
                                    </label>
                                    <div className="space-y-[0.5px]">
                                        <h2 className="text-[17px] font-bold">
                                            {project?.projectName}
                                        </h2>
                                        <p className="text-[16px] text-gray-400">
                                            {project?.configuration
                                                ? ` ${
                                                      project?.configuration
                                                  } ${' '}|`
                                                : ''}{' '}
                                            {project?.unitArea
                                                ? ` ${
                                                      project?.unitArea
                                                  } ${' '}SqFt`
                                                : ''}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className={`text-white w-full py-3 bg-primary tracking-widest rounded-md ${
                            !selectedProject
                                ? 'cursor-not-allowed bg-opacity-40'
                                : ''
                        }`}
                        onClick={() => {
                            window?.webengage?.track('PropertyCardViewed', {
                                propertyId: `${selectedProject?.propertyId}`
                            });
                            if (userStatus !== 'REGISTERED') {
                                setShowUnregisteredModal(true);
                                return;
                            } else {
                                setStep((prev) => prev + 1);
                                setListOtherProperty(false);
                                if (projectChanged) {
                                    // Reset values only if the user selected a new project
                                    setFurnishType(null);
                                    setExpectedRent(null);
                                    setRentOutTime(null);
                                    setSecurityDeposit(null);
                                }
                            }
                        }}
                        disabled={!selectedProject}
                    >
                        Next
                    </button>

                    {!config?.rental?.hideListAnotherProperty && (
                        <button
                            className="flex space-x-2 items-center"
                            onClick={listPropertyHandler}
                        >
                            {NotListing}{' '}
                            <span className="text-primary underline text-[16px] font-semibold pb-1">
                                List another property
                            </span>
                        </button>
                    )}
                </div>
            )}
        </>
    );
};

export default PropertyList;
